export default "__VITE_ASSET__702f5097__"